// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WSt8b","field":"styles_field__v1CYW","fieldCol":"styles_fieldCol__ZgXeP","diffCol":"styles_diffCol__XOueG","diff":"styles_diff__YLfFX"};